import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 * @deprecated since version 8.1.0
 * @tdr-deprecated-date: 2022-04-11
 */
export default svgIcon(React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" },
    React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M14.246 20L12 22.054l20.039 21.911 19.96-21.832v-.002l-2.245-2.053-17.715 19.376z" })), 'ChevronDown');
//# sourceMappingURL=ChevronDown.js.map